module.exports = __webpack_public_path__ + "static/media/chevron.f5a0b473.svg";